import { render, staticRenderFns } from "./ChatFeedback.vue?vue&type=template&id=403ef889&"
import script from "./ChatFeedback.vue?vue&type=script&lang=js&"
export * from "./ChatFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ChatFeedback.vue?vue&type=style&index=0&id=403ef889&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports